import axios from "axios";
import moment from "moment";
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import { getStorageValues } from "../../shared/CommonFunctions";
import { getApiBaseUrl } from "../../utils/apiConfig";

const EnquiryFollowup = forwardRef(({ data }, ref) => {
  const [alert, setAlert] = useState(null);
  const [followupList, setFollowupList] = useState([]);
  const [followupDate, setFollowupDate] = useState(new Date());
  const [remarks, setRemarks] = useState("");
  const [showButtons, setShowButtons] = useState(false);

  const isSold = Boolean(data?.IsSold);

  const enquiryId = data?.EnquiryId;
  const userId = useMemo(() => getStorageValues("userId"), []);

  useImperativeHandle(ref, () => ({
    refreshFollowup: fetchFollowups
  }));

  async function fetchFollowups() {
    if (!enquiryId) {
      setFollowupList([]);
      return;
    }
    try {
      const params = {
        UserId: userId,
        EnquiryId: enquiryId
      };

      const res = await axios.get(
        `${getApiBaseUrl()}/getEnquiryFollowupByEnquiryId`,
        { params }
      );

      if (res.status === 200) {
        const payload = res?.data?.data;
        const normalized = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.[0])
            ? payload[0]
            : [];
        setFollowupList(normalized);
      }
    } catch (err) {
      console.log(err);
      CreateAlert("Problem loading follow-up", "Error", setAlert);
    }
  }

  async function saveFollowup() {
    if (!enquiryId) {
      CreateAlert("Missing enquiry reference", "Error", setAlert);
      return;
    }
    if (isSold) {
      CreateAlert("Cannot add follow-up for a sold enquiry", "Warning", setAlert);
      return;
    }
    if (!remarks.trim()) {
      CreateAlert("Please add remarks", "Warning", setAlert);
      return;
    }
    try {
      const payload = {
        UserId: userId,
        EnquiryId: enquiryId,
        FollowupDate: moment(followupDate).format("YYYY-MM-DD HH:mm:ss"),
        FollowupRemarks: remarks
      };

      const res = await axios.post(
        `${getApiBaseUrl()}/saveEnquiryFollowup`,
        payload
      );

      if (res.status === 200) {
        setRemarks("");
        setShowButtons(false);
        fetchFollowups();
        CreateAlert("Follow-up saved!", "Success", setAlert);
      }
    } catch (err) {
      console.log(err);
      CreateAlert("Problem saving follow-up", "Error", setAlert);
    }
  }

  useEffect(() => {
    fetchFollowups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enquiryId]);

  useEffect(() => {
    if (isSold) {
      setShowButtons(false);
    }
  }, [isSold]);

  return (
    <>
      <SKAlerts alert={alert} />
      
      <div className="row" style={{ margin: "10px" }}>
        { !isSold && (
        <div className="col-lg-3">
          <label className="form-label">Follow-up Date</label>
          <DatePicker
            className="form-control"
            selected={followupDate}
            onChange={(date) => setFollowupDate(date)}
            minDate={new Date()}
          />
        </div>)}

          { !isSold && (
        <div className="col-lg-9">
          <label className="form-label">Remarks</label>
          <textarea
            className="form-control"
            rows="1"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Add follow-up details..."
            onFocus={() => setShowButtons(true)}
          ></textarea>
              <div className="mt-2">
                <button className="btn btn-primary btn-sm me-2" onClick={saveFollowup}>
                  Save
                </button>
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => {
                    setRemarks("");
                    setShowButtons(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            
        </div>)}

        <div className="col-12">
          <div className="scrollable-comments">
            {followupList?.map((f, i) => (
              <div className="card card-bg-light mg-em" key={f?.EnquiryFollowupId || i}>
                <div className="card-body" style={{ margin: "5px" }}>
                  <div className="d-flex">
                    <div className="me-3">
                      <span className="avatar avatar-rounded">
                        <img
                          alt=""
                          src={`/assets/img/profiles/${f?.UserImagePath || "avatar-03.jpg"}`}
                        />
                      </span>
                    </div>
                    <div>
                      <div className="fw-semibold">{f?.FullName || "-"}</div>
                      <div dangerouslySetInnerHTML={{ __html: f?.FollowupRemarks || "" }}></div>
                      <small className="text-muted">
                        {f?.CreatedDate
                          ? moment(f.CreatedDate).format("MM/DD/YYYY, h:mm A")
                          : ""}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {(!followupList || followupList.length === 0) && (
              <div className="text-muted small">No follow-ups available.</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
});

export default EnquiryFollowup;
